import { 
  OFFER_TELCEL_POSPAGO, 
  OFFER_TELCEL_RECARGA,
  OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE,
  OFFER_TELCEL_PAQUETE_INTERNET_AMIGO,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO,
  OPEN_NEW_MICROAPP,
  REDIRECT,
  OFFER_TELCEL_AMIGO_PAGUITOS,
  OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN,
  OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO,
  OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO,
  IDS_AVAILABLE_TO_SERVICE_BALANCE_TELCEL,
  BROWSE,
  NAVIGATE,
  SERVICE_ID_TELCEL_PLANES,
  SERVICE_ID_TELCEL_POSPAGO,
  AMIGO_PAGUITOS,
  SERVICE_ID_TELCEL_RECARGA,
  ARCUS_BILLER_IDS_TELCEL_CONTENEDOR,
  ARCUS_BILLER_IDS,
  VALUES_EVENT_DD_FULL_STORY
} from "../../constants";
import { datadogRum } from '@datadog/browser-rum';
import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";
import defaultMessagesMiniAppTelcel from "../../services/messaging/miTelcel.json"

export function validateUserAgent () {
  if (/Android/i.test(navigator.userAgent)) {
    return "android"
  }
}

export function getMessage (messages, code, flux){
  const message = messages.find(message => message.code ===  code);
  if (message) {
    return message;
  } else {
    if (flux && flux === "MiniAppTelcel") {
      return defaultMessagesMiniAppTelcel.find(message => message.code === code)
    }
  } 
}

export function getTypeOfferValue(typeOffer){
  switch (typeOffer) {
    case "OFFER_TELCEL_POSPAGO":
      return OFFER_TELCEL_POSPAGO
    case "OFFER_TELCEL_RECARGA":
      return OFFER_TELCEL_RECARGA
    case "OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE":
      return OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE
    case "OFFER_TELCEL_PAQUETE_INTERNET_AMIGO":
      return OFFER_TELCEL_PAQUETE_INTERNET_AMIGO
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN
    case "OFFER_TELCEL_AMIGO_PAGUITOS":
      return OFFER_TELCEL_AMIGO_PAGUITOS
    case "OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL":
      return OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL
    case "OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO":
      return OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO
    case "OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO":
      return OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO
    default:
      break;
  }
}

export function getTypeEventValue(typeEvent){
  switch (typeEvent) {
    case "OPEN_NEW_MICROAPP":
      return OPEN_NEW_MICROAPP
    case "REDIRECT":
      return REDIRECT
    case "BROWSE":
      return BROWSE
    case "NAVIGATE":
      return NAVIGATE
    default:
      break;
  }
}

export const datadogMonitor = (tagServiceId, sessionReplaySampleRate) => {
  console.log(sessionReplaySampleRate, '' , tagServiceId, 'DD_sessionReplaySampleRate')
  const {REACT_APP_DATADOG_IOS_APPLICATION_ID, REACT_APP_DATADOG_APPLICATION_ID} = process.env

  const applicationId = validateUserAgent() === "android" ? 
    REACT_APP_DATADOG_APPLICATION_ID : 
    REACT_APP_DATADOG_IOS_APPLICATION_ID
  console.log(applicationId, "applicationId log");
  const allowedOrigins = process.env.REACT_APP_DATA_DOG_ALLOWED_ORIGINS.split(',') || [];
  allowedOrigins.push(/^https:\/\/.*\.claropay\.com/)
  allowedOrigins.push((url) => url.startsWith("https://uatapi.claropay.com"))
  datadogRum.init({
    applicationId: applicationId,
    clientToken: `${process.env.REACT_APP_DATADOG_CLIENT_TOKEN}`,
    site: `${process.env.REACT_APP_DATADOG_SITE}`,
    env: `${process.env.REACT_APP_DATADOG_ENV}`,
    service: `${tagServiceId}`,
    allowedTracingOrigins: allowedOrigins,
    trackInteractions: true,
    allowedTracingUrls: [
      'https://uatmicroapps.claropay.com'
    ],
    // version: '1.0.0', 
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    enableExperimentalFeatures: ['feature_operation_vital'],
  });
  datadogRum.startSessionReplayRecording();
}

export const startFeaturedDatadog = (
  nameOperation, // Nombre del evento
  idOperationKey, // id único que vincula los eventos en una sesión
  serviceId,  // Dato extra(información adicional)
  description // Dato extra(información adicional) 
) => {
  const options = {
    operationKey: idOperationKey,
    context: { serviceId: serviceId },
    description: description,
  };
  if(VALUES_EVENT_DD_FULL_STORY.includes(nameOperation)){ 
    console.log("🚀 ~ DD_ start " + nameOperation);
    datadogRum.startFeatureOperation(
      nameOperation,
      options
    );
  } 
}

export const succedFeaturedDatadog = (
  nameOperation, 
  idOperationKey, 
  serviceId, 
  description
) => {
  const options = {
    operationKey: idOperationKey,
    context: { serviceId: serviceId },
    description: description,
  };
  if(VALUES_EVENT_DD_FULL_STORY.includes(nameOperation)){ 
    console.log("🚀 ~ DD_ succed " + nameOperation);
    datadogRum.succeedFeatureOperation(
      nameOperation,
      options
    );
  } 
}

export const failedFeaturedDatadog = (
  nameOperation, 
  idOperationKey, 
  serviceId, 
  description, 
  failure_reason, 
) => {
  const options = {
    operationKey: idOperationKey,
    context: { serviceId: serviceId },
    description: description,
  };
  if(VALUES_EVENT_DD_FULL_STORY.includes(nameOperation)){ 
    console.log("🚀 ~ DD_ failed " + nameOperation + " - " + failure_reason);
    datadogRum.failFeatureOperation(
      nameOperation,
      failure_reason, // failureReason ('error' | 'abandoned' | 'other')
      options
    );
  } 
}


const validateCookieExist = (cname) => {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return true
      }
    }
    return false;
}

export const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const setDomiciliationMsgInitialDate = (text, date) => {
  const setInitialDate = text.replaceAll("{fecha}", date);
  return setInitialDate.replaceAll("{periodicidad}", "mes");
};

export const formatEpochDate = (epochDate) => {
  const date = new Date(Number(epochDate));
  const yyyy = date.getFullYear();
  const numberString = (String(date.getMonth() + 1))
  const mm = (numberString.length) ? "0" + (numberString) : numberString
  const day = date.getDate();
  const dd = (day < 10) ? "0" + day : day
  return dd + "/" + mm + "/" + yyyy
};

export const getSumDaysDate = (days) => {
  const today = new Date();
  const tzoffset = (new Date()).getTimezoneOffset() * 60000;
  return new Date(today.setDate(today.getDate() + days) - tzoffset)
    .toISOString()
    .split("T")[0];
  
}

export const getRequirementsAdvancementClaroPay = (
  user, 
  isContainerTelcel, 
  serviceId,
  tagServiceId,
  prepago
) => {
  let isUserApprove = false;
  if(
    (
      serviceId == SERVICE_ID_TELCEL_PLANES || 
      serviceId == SERVICE_ID_TELCEL_RECARGA && tagServiceId != "serviciopagotelcelMenu"
    ) ||
    tagServiceId == "serviciopagotelcelMenu" && prepago
  ){
    if(user.advancePayment && !isContainerTelcel){
      if(user.advancePayment.approved && Number(user.advancePayment.score) > 0){
        isUserApprove = true;
      }
    }
  }
  return isUserApprove;
}

export const handleClickBannersTelcel = (onclick, isAnonimous, handleIpuntClick) => {
  let action = isAnonimous 
    ? onclick.notLoggued 
    : onclick.loggued;

  const [actionText, microAppId] = action.split("__");
  action = actionText && microAppId && actionText === "openMicroApp"  
    ? "openMicroApp" 
    : action;
  
  console.log('BANNER__ACTION', action);

  switch (action) {
    case "openLogin":
      ClaroSDKService.openLogin();
      handleIpuntClick()
      break;

    case "openOnboarding":
      ClaroSDKService.openOnBoarding(false);
      handleIpuntClick()
      break;

    case "openMicroApp":
      ClaroSDKService.openMicroApp(microAppId);
      handleIpuntClick()
      break;

    case "setN2":
      const cardInfoItemClaroPay = {
        value: "claro-pay",
        mark : "999",
        type :  0,
        lastDigits : " ",
        update: false
      };

      handleIpuntClick(null, "cardId", cardInfoItemClaroPay)
      break;
  
    default:
      break;
  }
}

export const formatCurrency = new Intl.NumberFormat("en-Latn-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 2,
});

export const formatRawCurrency = (value) => {
  return "$" + Math.floor(value).toString();
};


export const getUserApplyForAdvance = (user, amount) => {
  const {advancePayment} = user
  if(advancePayment){
    const {creditAmount, score, approved } = advancePayment
    console.log(advancePayment && Number(score) > 0 &&  approved && creditAmount >= amount, "DENTROCD");
    return advancePayment && Number(score) > 0 &&  approved && creditAmount >= amount
  }
}
export const getSelectedPlanByCost = (plans, cost) => {
  plans = plans.detail ? plans.detail : plans;
  return plans.find(plan=>plan.cost===cost);
}

export const getPlansForUpsell = (plans, cost) => {
  let plansForUpsell = plans.detail ? plans.detail : plans;
      plansForUpsell = plansForUpsell.filter( plan => plan.cost >= cost);
      plansForUpsell.sort((a, b) =>  a.cost - b.cost);

  let seenMB = {}; 

  plansForUpsell = plansForUpsell.filter(plan => {
    if (plan.mb && !seenMB[plan.mb]) {
      seenMB[plan.mb] = true; 
      return true; 
    }
    return false; 
  });

  plansForUpsell = plansForUpsell.filter(plan => plan.cost > cost);
  return plansForUpsell;
}

export const getNextPlanUpsell = (plansForUpsell, cost) => {
  const currentIndex = plansForUpsell.findIndex(plan => plan.cost === cost);
  return plansForUpsell[currentIndex+1];
}

export const existConfigFavorites = (dataConfigInputs, amount) => {
  const dataConf = dataConfigInputs.find(config => config.id === 'buttonBox');
  if (dataConf && dataConf.cp) {
    return dataConf.cp.find(input => input.id === 'favoritos') ? true : false
  }
}

export function getDomiciliationExpirationDate(expirationDate) {
  console.log(expirationDate, "Fecha que llega");
  
  const dateFromForm = new Date(expirationDate)
  console.log(dateFromForm, "Fecha seleccionada del form a new date");

  const monthFromForm = dateFromForm.getMonth(); //(January gives 0)
  console.log(monthFromForm, "Mes Fecha form");
  
  const dayFromform = dateFromForm.getDate()
  console.log(dayFromform, "dia fecha form");

  const yearFromForm = dateFromForm.getFullYear();
  console.log(yearFromForm, "año fecha form");
  
  const currentDate = new Date();
  console.log(currentDate, "Fecha actual");

  const currentday = currentDate.getDate();
  console.log(currentday, "Dia aactual");

  const currentMoth = currentDate.getMonth();
  console.log(currentMoth, "Mes actual");

  if(monthFromForm === 11){
    console.log("El mes es Diciembre");
    const nextMonthYear = new Date(`${yearFromForm + 1}/01/01`);
    console.log(nextMonthYear, "Mes siguiene año");

    const nextMonthOfYearTotalDays = new Date(yearFromForm+1, 1, 0).getDate();
    console.log(nextMonthOfYearTotalDays, "Dias totales mes siguiente año ")
    
    const nextMonthTotalDays = new Date(yearFromForm, monthFromForm+2, 0).getDate();
    console.log(nextMonthTotalDays, "Siguiente mes dias totales");

    if(dayFromform <= currentday){
      if(dayFromform <=  nextMonthOfYearTotalDays){
        console.log(dayFromform, "dia seleccionado es menor o igual a dia actual y  menor a total de dias del sigueinte mes ");
        return `${yearFromForm+1}/01/${dayFromform}`
      }
      if( dayFromform > nextMonthTotalDays){
        console.log(dayFromform, "dia seleccionado es menor o igual a dia actual y  mayor a total de dias del sigueinte mes ");
        return `${yearFromForm+1}/01/${nextMonthTotalDays}`
      }
    }
    return expirationDate

  } else {

    const nextMonthDate = new Date(`${yearFromForm}/${monthFromForm+2}/01`);
    console.log(nextMonthDate, "Fecha siguiente mes");

    const nextMonthTotalDays = new Date(yearFromForm, monthFromForm+2, 0).getDate();
    console.log(nextMonthTotalDays, "Siguiente mes dias totales");
    
    if(monthFromForm < currentMoth ){
      console.log(monthFromForm, "mes seleccionado es menor a mes actual");
      if(dayFromform <=  nextMonthTotalDays){
        console.log(dayFromform, "dia seleccionado es menor o igual a total de dias del siguiente mes");
        return `${yearFromForm}/${monthFromForm+2}/${dayFromform}`
      }
      if( dayFromform > nextMonthTotalDays){
        console.log(dayFromform, "dia seleccionado es mayor al total de dias del siguiente mes ");
        return `${yearFromForm}/${monthFromForm+2}/${nextMonthTotalDays}`
      }
      return expirationDate
    } else if(monthFromForm === currentMoth ) {
      console.log(monthFromForm, "mes seleccionado es igual mes actual");
      if(dayFromform <= currentday && dayFromform <=  nextMonthTotalDays){
        console.log(dayFromform, "dia seleccionado es menor o igual a dia actual y  menor a total de dias del sigueinte mes ");
        return `${yearFromForm}/${monthFromForm+2}/${dayFromform}`
      }
      if( dayFromform <= currentday && dayFromform > nextMonthTotalDays){
        console.log(dayFromform, "dia seleccionado es menor o igual a dia actual y  mayor a total de dias del sigueinte mes ");
        return `${yearFromForm}/${monthFromForm+2}/${nextMonthTotalDays}`
      }
      return expirationDate
    } else {
      return expirationDate
    }
  }
}

export function buttonDomiciliationConfigExist(dataConfigElements){
  const buttonBoxElements = dataConfigElements.find((elem) => elem.id == "buttonBox" );
  if(buttonBoxElements){
    const  result = buttonBoxElements.cp.find((button) => button.id == "domiciliar" )
    return result ? true : false
  }else{
    return false
  }
}

export function buttonMorePackagesConfigExist(dataConfigElements){
  const buttonBoxElements = dataConfigElements.find((elem) => elem.id == "buttonBox" );
  if(buttonBoxElements){
    const  result = buttonBoxElements.cp.find((button) => button.id == "mas_paquetes_pospago" )
    return result ? true : false
  }else{
    return false
  }
}

export function getPaymentFlowForTaggeo(isAnonimous, msisdn, paymentMethods) {
  if (isAnonimous && msisdn) {
    return "Solo MSISDN";
  }

  if (!isAnonimous) {
    if (!paymentMethods || (!paymentMethods.hasN2 && paymentMethods.cardList.length === 0)) {
      return "Usuario sin método"
    }
    if (paymentMethods && (paymentMethods.hasN2 || paymentMethods.cardList.length > 0)) {
      return "Usuario con método"
    }
  }
}

export const getUrlBalances = (isContainer, serviceId, needsDelay) => {
  const {
    REACT_APP_BALANCE_CP_TELCEL,
    REACT_APP_BALANCE_CP_TELCEL_APIKEY,
    REACT_APP_BALANCE_CP_SERVICIOS,
    REACT_APP_BALANCE_CP_SERVICIOS_APIKEY
  } = process.env
  const isBalanceTelcel =  IDS_AVAILABLE_TO_SERVICE_BALANCE_TELCEL.includes(
    serviceId
  )
  if(isContainer){
    if(isBalanceTelcel){
      return  { 
        url : REACT_APP_BALANCE_CP_TELCEL, 
        apiKey : REACT_APP_BALANCE_CP_TELCEL_APIKEY,
        needsDelay : needsDelay
      }
    } else {
      return { 
        url : REACT_APP_BALANCE_CP_SERVICIOS, 
        apiKey : REACT_APP_BALANCE_CP_SERVICIOS_APIKEY,
        needsDelay : false
      }
    }
  } else {
    if(isBalanceTelcel){
      return { 
        url : REACT_APP_BALANCE_CP_TELCEL, 
        apiKey : REACT_APP_BALANCE_CP_TELCEL_APIKEY,
        needsDelay : needsDelay
      }
    } else {
      return { 
        url : REACT_APP_BALANCE_CP_SERVICIOS, 
        apiKey : REACT_APP_BALANCE_CP_SERVICIOS_APIKEY,
        needsDelay : false
      }
    }
  }
}

export const getDomiciliationWindowId = (requestCodeKey = "") => {
  return `${requestCodeKey}_pago_servicios_${sessionStorage.getItem("domiciliationWindowId")}`
};

export const assignTagServiceTelcel = (serviceId, tagServiceId) => {
  let newTagServiceId;

  switch (true) {
    case (serviceId === SERVICE_ID_TELCEL_PLANES):
      newTagServiceId = 'telcelAmigoSinLimitePs';
      break;
    case (serviceId === SERVICE_ID_TELCEL_POSPAGO):
      newTagServiceId = 'TelcelPospagoPS';
      break;
    case (serviceId === AMIGO_PAGUITOS):
      newTagServiceId = 'amigopaguitos';
      break;
    case (serviceId === SERVICE_ID_TELCEL_RECARGA):
      newTagServiceId = 'serviciopagotelcel';
      break;
    default:
      newTagServiceId = tagServiceId;
  }

  return newTagServiceId
}

export const getServicesTelcel = (serviceId) => {
  switch (Number(serviceId)) {
    case -1://Se define -1 para tagServiceId: "amigopaguitos"
      return "servicios telcel";
    case 146:
      return "servicios telcel";
    case 113:
      return "servicios telcel";
    case 143:
      return "servicios telcel";
    case 247:
      return "servicios telcel";
    case 254:
      return "servicios telcel";
    case 285:
      return "servicios telcel";
    default:
      return "terceros";
  }
}

/**
 * Get user navigator by navigator object interface
 * @return {null|Array} Array if navigator match, otherwise returns false
 ***/
export const getNavigator = {
  isIOS: () => {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i) || false;
  },
  isAndroid: () => {
    return navigator.userAgent.match(/Android/i) || false;
  }
};

export const idIsvalidCheckBalanceArcus = (isContainerTelcel, serviceId) => {
  if(isContainerTelcel){
    return ARCUS_BILLER_IDS_TELCEL_CONTENEDOR.includes(serviceId)
  } else {
    return ARCUS_BILLER_IDS.includes(serviceId)
  }
};

export const taggeoCleanString = (texto) => {
  console.log(texto, "RESPONSEMESSAGE");
  if(texto){
  return texto
    // 1. Normaliza para separar acentos
    .normalize("NFD")
    // 2. Elimina los caracteres diacríticos (acentos)
    .replace(/[\u0300-\u036f]/g, "")
    // 3. Convierte a minúsculas
    .toLowerCase()
    // 4. Elimina comas, puntos, signos de exclamación/interrogación y comillas
    .replace(/[.,!?¿¡"']/g, "")
    // 5. Elimina espacios extra al inicio y final
    .trim();
  }else{
    return ""
  }
}

export const getCvvWithTokenizationResponse = (
  isAnonimous, 
  cvvWithTokenizationResponse, 
  isUnificationFlow, 
  commissionRules
) => {
    if (isUnificationFlow){
      return commissionRules[0].cvv
    }
    if (!isAnonimous && !cvvWithTokenizationResponse) {
        return commissionRules[0].cvv
    } else {
        return false
    }
}



export const parseEventInformation = (eventInformation: any) => {
  if (typeof eventInformation === 'string') {
    try {
      return JSON.parse(eventInformation);
    } catch (error) {
      console.error('Error parseando eventInformation', error);
      return {};
    }
  }

  return eventInformation || {};
};
